module.exports = __webpack_public_path__ + "static/media/reynolds.44cd8834.jpg";